import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c3378f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "upAnalysis"
}
const _hoisted_2 = { class: "topBox" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "code" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = {
  key: 0,
  class: "icon-img",
  src: "https://upload.9fzt.com/production/9fzt-stock-pc-ssr/assets/mainchart/downicon.png"
}
const _hoisted_8 = {
  key: 1,
  class: "icon-img",
  src: "https://upload.9fzt.com/production/9fzt-stock-pc-ssr/assets/mainchart/upicon.png"
}
const _hoisted_9 = { class: "detail" }
const _hoisted_10 = { class: "xj" }
const _hoisted_11 = { class: "xjp" }
const _hoisted_12 = { class: "upType" }
const _hoisted_13 = { style: {"font-weight":"700"} }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("更新于")
const _hoisted_16 = { style: {"margin-left":"5px"} }
const _hoisted_17 = {
  key: 0,
  class: "strengthBox"
}
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "strengthTitle" }
const _hoisted_20 = {
  key: 1,
  class: "noData"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "15：00开始更新", -1))
const _hoisted_23 = {
  key: 1,
  class: "loading"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"15px"} }, "正在加载数据，请耐心等待...", -1))
const _hoisted_26 = {
  key: 2,
  class: "noData"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "暂无数据", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpandableText = _resolveComponent("ExpandableText")!

  return (_openBlock(), _createElementBlock("div", {
    class: "upAnalysisBox",
    style: _normalizeStyle(_ctx.theme == 'dark' ? 'background-color: #070707;color: #E4E4E4;' : '' )
  }, [
    (_ctx.symbol != "CLSDATA" && !_ctx.loading && _ctx.name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "nameBox",
              onDblclick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dbClickRow({ Exch:_ctx.market, Inst:_ctx.symbol})))
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.name), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.symbol), 1)
            ], 32),
            _createElementVNode("div", {
              class: _normalizeClass([ 'priceBox', _ctx.dataState == 1 ? 'up' : _ctx.dataState == -1 ? 'down' : ''])
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(Number(_ctx.LastPrice).toFixed(2)), 1),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.dataState == -1)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : _createCommentVNode("", true),
                (_ctx.dataState == 1)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.isToday ? (_ctx.PreClosePrice && _ctx.LastPrice ?  ((_ctx.LastPrice - _ctx.PreClosePrice) > 0 ? '+' : '') + (_ctx.LastPrice - _ctx.PreClosePrice).toFixed(2) : '--' ) : (( typeof _ctx.Updown === 'number' ) ? (_ctx.Updown > 0 ? '+' : '') + _ctx.Updown?.toFixed(2) : '--')), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.rise ? (_ctx.rise > 0 ? '+' : '') + Number(_ctx.rise)?.toFixed(2) : '--') + "%", 1)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.countDays&&_ctx.countBoard)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "typeBox",
                    style: _normalizeStyle(_ctx.theme == 'dark' ? 'background: #392B18;color: #FFB179;' : 'background: #FFE4BF;color:#FF6B00' )
                  }, _toDisplayString(_ctx.boardText(_ctx.countDays,_ctx.countBoard)), 5))
                : _createCommentVNode("", true),
              (_ctx.upLimitType)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "typeBox",
                    style: _normalizeStyle(_ctx.theme == 'dark' ? 'background: #392B18;color: #FFB179;' : 'background: #FFE4BF;color:#FF6B00' )
                  }, _toDisplayString(_ctx.upLimitType), 5))
                : _createCommentVNode("", true)
            ]),
            (_ctx.upReason)
              ? (_openBlock(), _createBlock(_component_ExpandableText, {
                  key: 0,
                  class: "upReason",
                  style: _normalizeStyle(_ctx.theme == 'dark' ? 'background: rgb(38, 38, 38);color: #fff;' : 'background: rgb(242, 245, 250);color:#000' ),
                  text: `${_ctx.upReasonPrefix}${_ctx.upReason}`
                }, null, 8, ["style", "text"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "upTime",
            style: _normalizeStyle(_ctx.theme == 'dark' ? 'background: #1F1F1F;' : 'background: #F2F5FA;' )
          }, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.upLimitStrengthTitle), 1),
            (_ctx.upLimitStrengthTime)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.timestampToDate(_ctx.upLimitStrengthTime)), 1)
                ]))
              : _createCommentVNode("", true)
          ], 4),
          (_ctx.noData == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass([ 'upStrength', _ctx.theme == 'dark' ?  `up${_ctx.upLimitStrength}dark` : `up${_ctx.upLimitStrength}`])
                }, _toDisplayString(_ctx.upLimitStrengthType), 3),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.upLimitStrengthText), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strengthArr, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "strengthArr",
                    key: item.name,
                    style: _normalizeStyle(_ctx.theme == 'dark' ? 'background-color: #262626;' : 'background: #F2F5FA;' )
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", {
                        class: "name",
                        style: _normalizeStyle(_ctx.theme == 'dark' ? ' color: #E4E4E4;' : 'color: #4D4D4D' )
                      }, _toDisplayString(item.name), 5),
                      (item.type)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass([ 'type' , _ctx.theme == 'dark' ?  `up${item.type}dark` : `up${item.type}` ])
                          }, _toDisplayString(item.typeName), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      class: "res",
                      style: _normalizeStyle(_ctx.theme == 'dark' ? 'color: #AAAAAA;' : 'color: #7D7D7D;' )
                    }, _toDisplayString(item.reason), 5)
                  ], 4))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.noData == -1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("img", { src: _ctx.img }, null, 8, _hoisted_21),
                _hoisted_22
              ]))
            : _createCommentVNode("", true)
        ]))
      : ((_ctx.loading || !_ctx.name)&&(_ctx.symbol != "CLSDATA"))
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("img", { src: _ctx.loadingImg }, null, 8, _hoisted_24),
            _hoisted_25
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("img", { src: _ctx.img }, null, 8, _hoisted_27),
            _hoisted_28
          ]))
  ], 4))
}